import { LogoutState } from './logout.types'

const initialState: LogoutState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
